export const getId = name => `id-${name.toLowerCase().replace(/\s/ig, '-')}`;
